import { Container, Row, Col } from "react-bootstrap";

function FormContainer({ children, centered = false }) {
  if (centered) {
    return (
      <div className="auth-stage" style={{ backgroundImage: "url(/defaults/shore.svg?v=7)" }}>
        <div className="auth-card">{children}</div>
      </div>
    );
  }

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col xs={12} md={6}>
          {children}
        </Col>
      </Row>
    </Container>
  );
}

export default FormContainer;
